import axios, { AxiosInstance, AxiosResponse } from "axios";
import { getAuth, getIdToken } from "firebase/auth";
import { BASE_SERVER_URL } from "../App";
import { AffirmationWithCategory } from "../interfaces/tell_me/affirmationWithCategory.types";
import { Category, CreateCategoryType, UpdateCategoryType } from "../interfaces/tell_me/category.types";
import { ReelWithCategory } from "../interfaces/tell_me_watch/reel.types";
import { IReelsCategoryCreate, IReelsCategoryUpdate, ReelsCategory } from "../interfaces/tell_me_watch/reelsCategory.types";

interface API_RESPONSE {
    success: boolean,
    message: string
}
const API_KEY = "3936c2bac849a02d8f36c04a8312f41e7c4d735e70536ae254c44142fd8a0d3f";

const getAxios = async (): Promise<AxiosInstance> => {
    const authentication = getAuth();
    const user = authentication.currentUser;

    if (user) {
        const idToken = await getIdToken(user);
        return axios.create({
            baseURL: BASE_SERVER_URL,
            headers: {
                Authorization: `Bearer ${idToken}`
            }
        });
    }

    console.log("Unauthorized!");
    return axios.create({
        baseURL: BASE_SERVER_URL,
    });

}

const getAllAffirmations = async (): Promise<Array<AffirmationWithCategory>> => {
    try {
        const instance = await getAxios();
        const response = await instance.get("/affirmation/all");
        return response.data.data as Array<AffirmationWithCategory>;
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return [];
    }

}



const getAllCategories = async (): Promise<Array<Category>> => {
    try {
        const instance = await getAxios();
        const response = await instance.get("/category/all");
        return response.data.data as Array<Category>;
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return [];
    }

}

// Create Affirmations, if it success return true, else false.
const addAffirmations = async (affirmations: Array<AffirmationWithCategory>): Promise<API_RESPONSE> => {
    try {
        const instance = await getAxios();
        const data = {
            affirmations: affirmations
        };
        const response = await instance.post("/affirmation", data);
        console.log(response);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}

// Update Affirmation
const updateAffirmation = async (affirmation: AffirmationWithCategory): Promise<API_RESPONSE> => {
    try {
        const instance = await getAxios();
        const data = {
            text: affirmation.text,
        };
        const response = await instance.put("/affirmation/" + affirmation.id, data);
        console.log(response);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }

}

// Delete Affirmation
const deleteAffirmations = async (affirmationId: string, deleteCategoryIds: Array<string>): Promise<API_RESPONSE> => {
    try {
        const instance = await getAxios();
        const data = {
            categoryIds: deleteCategoryIds,
        };
        const response = await instance.delete("/affirmation/" + affirmationId, { data: data });
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}

// Create Category
const createCategory = async (category: Category) => {
    try {
        const instance = await getAxios();
        const data: CreateCategoryType = {
            id: category.id,
            isActive: category.isActive,
            isPremium: category.isPremium,
            image: category.image,
            index: category.index,
            name: category.name,
        };
        const response = await instance.post("/category", data);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}

// Update Category
const updateCategory = async (category: UpdateCategoryType) => {
    try {
        const instance = await getAxios();
        const data: UpdateCategoryType = {
            id: category.id,
            lastUpdatedTime: category.lastUpdatedTime,
            isActive: category.isActive,
            isPremium: category.isPremium,
            image: category.image,
            index: category.index,
            name: category.name,
        };
        const response = await instance.put("/category", data);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}

// Delete Category
const deleteCategory = async (categoryId: string) => {
    try {
        const instance = await getAxios();

        const response = await instance.delete("/category/" + categoryId);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}

// Get All Reels
const getAllReels = async () => {
    try {
        const instance = await getAxios();
        const response = await instance.get("/reels/all");
        return response.data.data as Array<ReelWithCategory>;
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return [];
    }
}
// Get All Reels Categories
const getAllReelsCategories = async () => {
    try {
        const instance = await getAxios();
        const response = await instance.get("/reelsCategory/all");
        return response.data.data as Array<ReelsCategory>;
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return [];
    }
}
// Add a Reel To Selected Categories
const addReel = async (videoId: string, categoryIds: string[]): Promise<API_RESPONSE> => {
    try {
        const instance = await getAxios();
        const data = {
            videoId,
            categoryIds,
        };
        const response = await instance.post("/reels", data);
        console.log(response);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}
// Update the Reel's Categories
const updateReel = async (videoId: string, categoryIds: string[]): Promise<API_RESPONSE> => {
    try {
        const instance = await getAxios();
        const data = {
            videoId,
            categoryIds,
        };
        const response = await instance.put("/reels", data);
        console.log(response);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}
// Delete Reel from all categories contains it.
const deleteReel = async (videoId: string): Promise<API_RESPONSE> => {
    try {
        const instance = await getAxios();
        const response = await instance.delete("/reels/" + videoId);
        console.log(response);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}
// Creates a reels category.
const createReelsCategory = async (category: IReelsCategoryCreate): Promise<API_RESPONSE> => {
    try {
        const instance = await getAxios();
        const response = await instance.post("/reelsCategory", category);
        console.log(response);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}

// Updates a reels category.
const updateReelsCategory = async (category: IReelsCategoryUpdate): Promise<API_RESPONSE> => {
    try {
        const instance = await getAxios();
        const response = await instance.put("/reelsCategory", category);
        console.log(response);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}

// Deletes a reels category.
const deleteReelsCategory = async (categoryId: string): Promise<API_RESPONSE> => {
    try {
        const instance = await getAxios();
        const response = await instance.delete("/reelsCategory/" + categoryId);
        console.log(response);
        return {
            success: true,
            message: response.data.message,
        };
    } catch (e: any) {
        console.log(e);
        console.log(e.response.data);
        return {
            success: false,
            message: e.response.data.message,
        };
    }
}



export {
    getAllAffirmations,
    getAllCategories,
    addAffirmations,
    updateAffirmation,
    deleteAffirmations,
    createCategory,
    updateCategory,
    deleteCategory,
    getAllReels,
    getAllReelsCategories,
    addReel,
    updateReel,
    deleteReel,
    createReelsCategory,
    updateReelsCategory,
    deleteReelsCategory,
};